// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   fetchCoupons,
//   fetchCouponById,
//   deleteCouponById,
// } from "../../../redux/couponSlice"; // Assuming you have a slice for coupons
// import editIcon from "../../../assets/images/editIcon.svg"; // Edit icon similar to your original example
// import { useTranslation } from "react-i18next";
// import { Menu, MenuItem, Button } from "@mui/material";
// import deleteIcon from "../../../assets/images/trash.svg";
// import WarningShipmentModalComponent from "../../../components/Modals/WarningShipmentModalComponent.js";

// const CouponList = () => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   // const { couponId } = useParams();
//   const [couponId,setCouponId] = useState('')
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

//   // State management
//   // const [couponType, setCouponType] = useState("active"); // Example type, you can manage different types of coupons

//   // Fetching data from Redux store
//   const coupons = useSelector((state) => state.coupon.couponsData);
//   // console.warn("coupons", coupons);

//   // Fetch coupons when component mounts or couponType changes
//   useEffect(() => {
//     dispatch(fetchCoupons());
//   }, [dispatch]);

//   // Function to handle coupon creation navigation
//   const handleCreateCoupon = () => {
//     navigate("/create-coupon");
//   };
//   // Open delete modal
//   const handleDeleteCouponBtnClick = (couponId) => {
//     setIsDeleteModalOpen(true);
//     setCouponId(couponId);
//   };
//   const onDeleteModalClose = () => {
//     setIsDeleteModalOpen(false);
//   };
//   const handleDelete = () => {
//     setIsDeleteModalOpen(true);

//     if (isDeleteModalOpen) {
//       console.log("handle Delete ::", couponId);
//       dispatch(deleteCouponById(couponId))
//         .then(() => {
//           dispatch(fetchCoupons());
//         })
//         .catch((error) => {
//           console.error("Error deleting category:", error);
//         });
//       onDeleteModalClose();
//     }
//   };

//   // Function to handle editing a
//   const handleEditCoupon = (couponId, coupon) => {
//     navigate(`/edit-coupon/${couponId}`, {
//       state: {
//         actionType: "edit", // Indicate this is for editing,
//         couponData: coupon,
//       },
//     });
//   };

//   return (
//     <div>
//       <div className="d-flex justify-content-between">
//         <div>
//           <h1 className="heading1">{t("couponList.title")}</h1>
//           <h5 className="heading2">{t("couponList.subtitle")}</h5>
//         </div>
//         <div>
//           <h5 className="navPageIfo">
//             Home /{" "}
//             <span style={{ color: "#C8C7C9" }}>{t("couponList.page")}</span>
//           </h5>
//         </div>
//       </div>

//       {/* Button to create a new coupon */}
//       <div className="d-flex justify-content-end mt-3">
//         <Button
//           style={{ backgroundColor: "#FCB332" }}
//           className="btn btn-primary green-btn"
//           onClick={handleCreateCoupon}
//         >
//           {t("couponList.createCoupon")}
//         </Button>
//       </div>

//       <div className="card mt-3 bg-stage">
//         <div className="card-body">
//           <div className="row">
//             {/* Loop through the coupons and display them */}
//             {coupons.length > 0 ? (
//               coupons.map((coupon) => (
//                 <div key={coupon._id} className="col-md-4">
//                   <div className="card mb-3">
//                     <div className="card-body">
//                       <div className="card-title">{coupon.code}</div>
//                       <p className="card-text">{coupon.description}</p>
//                       <p className="card-text">
//                         {t("couponList.discount")}: {coupon.discount}%
//                       </p>
//                       <p className="card-text">
//                         {t("couponList.validity")}: {coupon.startDate} -{" "}
//                         {coupon.endDate}
//                       </p>
//                       <Button
//                         style={{ backgroundColor: "#FCB332" }}
//                         className="btn btn-primary green-btn"
//                         onClick={() => handleEditCoupon(coupon._id, coupon)}
//                       >
//                         <img src={editIcon} alt="Edit" />
//                         {t("couponList.edit")}
//                       </Button>
//                       {/* <Button
//                         style={{ backgroundColor: "#FCB332" }}
//                         className="btn btn-primary green-btn"
//                         onClick={() => handleDeleteCouponBtnClick()}
//                       >
//                         <img src={editIcon} alt="Delete" />
//                         {t("couponList.delete")}
//                       </Button> */}
//                       <div >
//                         <button
//                           className="icon-clay"
//                           onClick={handleDeleteCouponBtnClick(coupon._id)}
//                         >
//                           <span className="inner-clay color-black">
//                             <img src={deleteIcon} alt="Delete" />
//                           </span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <p>{t("couponList.noCoupons")}</p>
//             )}
//           </div>
//         </div>
//       </div>
//       {isDeleteModalOpen && (
//         <WarningShipmentModalComponent
//           isOpen={isDeleteModalOpen}
//           onClose={onDeleteModalClose}
//           handleDelete={handleDelete}
//         />
//       )}
//     </div>
//   );
// };

// export default CouponList;
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchCoupons, deleteCouponById } from "../../../redux/couponSlice"; // Import Redux actions
import editIcon from "../../../assets/images/editIcon.svg";
import deleteIcon from "../../../assets/images/trash.svg";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import WarningShipmentModalComponent from "../../../components/Modals/WarningShipmentModalComponent.js";
import { getDate } from "../../../helpers/helperFunction.js";

const CouponList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [couponIdToDelete, setCouponIdToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  // Fetching coupons from Redux store
  const coupons = useSelector((state) => state.coupon.couponsData);

  // Fetch coupons when component mounts
  useEffect(() => {
    dispatch(fetchCoupons());
  }, [dispatch]);

  // Function to navigate to the create coupon page
  const handleCreateCoupon = () => {
    navigate("/create-coupon");
  };

  // Function to open delete confirmation modal
  const handleDeleteCouponBtnClick = (id) => {
    setCouponIdToDelete(id);
    setIsDeleteModalOpen(true);
  };

  // Function to close delete modal
  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setCouponIdToDelete(null);
  };

  // Function to delete coupon
  const handleDelete = async () => {
    if (couponIdToDelete) {
      try {
        await dispatch(deleteCouponById(couponIdToDelete)).unwrap();
        dispatch(fetchCoupons()); // Refresh the list
      } catch (error) {
        console.error("Error deleting coupon:", error);
      }
      onDeleteModalClose();
    }
  };

  // Function to navigate to the edit coupon page
  const handleEditCoupon = (id, coupon) => {
    navigate(`/edit-coupon/${id}`, {
      state: {
        actionType: "edit",
        couponData: coupon,
      },
    });
  };

  return (
    <div>
      {/* Header Section */}
      <div className="d-flex justify-content-between">
        <div>
          <h1 className="heading1">{t("couponList.title")}</h1>
          <h5 className="heading2">{t("couponList.subtitle")}</h5>
        </div>
        <div>
          <h5 className="navPageInfo">
            Home /{" "}
            <span style={{ color: "#C8C7C9" }}>{t("couponList.page")}</span>
          </h5>
        </div>
      </div>

      {/* Create Coupon Button */}
      <div className="d-flex justify-content-end mt-3">
        <Button
          style={{ backgroundColor: "#FCB332" }}
          className="btn btn-primary green-btn"
          onClick={handleCreateCoupon}
        >
          {t("couponList.createCoupon")}
        </Button>
      </div>

      {/* Coupon List */}
      <div className="card mt-3 bg-stage">
        <div className="card-body">
          <div className="row">
            {coupons.length > 0 ? (
              coupons.map((coupon) => (
                <div key={coupon._id} className="col-md-4">
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="card-title">{coupon.code}</h5>
                      <p className="card-text">{coupon.description}</p>
                      <p className="card-text">
                        {t("couponList.discount")}: {coupon.discount}%
                      </p>
                      <p className="card-text">
                        {t("couponList.validity")}:{" "}
                        {(getDate(coupon.startDate))} -{" "}
                        {(getDate(coupon.endDate))}
                      </p>

                      {/* Edit Button */}
                      <Button
                        style={{ backgroundColor: "#FCB332" }}
                        className="btn btn-primary green-btn me-2"
                        onClick={() => handleEditCoupon(coupon._id, coupon)}
                      >
                        <img src={editIcon} alt="Edit" className="me-1" />
                        {t("couponList.edit")}
                      </Button>

                      {/* Delete Button */}
                      <button
                        className="icon-clay"
                        onClick={() => handleDeleteCouponBtnClick(coupon._id)}
                      >
                        <span className="inner-clay color-black">
                          <img src={deleteIcon} alt="Delete" />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>{t("couponList.noCoupons")}</p>
            )}
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <WarningShipmentModalComponent
          isOpen={isDeleteModalOpen}
          onClose={onDeleteModalClose}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
};

export default CouponList;